var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_3048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7765 23.7347L26.7881 17.9277C27.243 17.4005 27.0334 16.5814 26.3812 16.3376L22.8776 15.0279C22.545 14.9036 22.1714 14.9649 21.896 15.1891L14.7246 21.0282C14.0777 21.555 14.3222 22.5956 15.136 22.7792L20.7994 24.0568C21.1596 24.1381 21.5353 24.0143 21.7765 23.7347Z",
    fill: "#F1B883",
    stroke: "#F1B883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00591 9.43676L6.29042 14.6092C5.82519 15.4954 6.08664 16.589 6.90238 17.1689L12.0738 20.8454C12.3523 21.0433 12.6767 21.1667 13.0164 21.2036L18.3426 21.7831C18.9262 21.8466 19.5082 21.6505 19.9344 21.2467L24.4353 16.9828C25.1233 16.331 25.2594 15.286 24.7613 14.4797L21.6511 9.44513C21.4368 9.09823 21.1216 8.82512 20.7477 8.66241L16.9321 7.00185C16.5069 6.81677 16.0305 6.78525 15.5846 6.91266L10.2273 8.44337C9.70145 8.5936 9.2601 8.95258 9.00591 9.43676Z",
    fill: "#FFD1A7",
    stroke: "#FFD1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2556 15.8948L23.6409 9.09072C23.5368 8.89473 23.3338 8.77222 23.1119 8.77222H18.1437C17.3959 8.77222 12.442 13.586 12.4887 14.5675C12.5355 15.549 15.0123 17.1381 16.4611 16.8577C17.4357 16.669 18.7208 15.6522 19.4942 14.9351C19.7156 14.7298 20.0535 14.7037 20.2946 14.8855L24.9308 18.3823C25.1867 18.5753 25.5491 18.5331 25.7538 18.2865L27.1874 16.5595C27.3428 16.3723 27.3698 16.1097 27.2556 15.8948Z",
    fill: "#F1B883",
    stroke: "#F1B883"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1378,
    y: 8.0354,
    width: 10.4649,
    height: 5.79129,
    rx: 1.4,
    transform: "rotate(116.44 10.1378 8.0354)",
    fill: "#7DCE9B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.4649,
    height: 5.79129,
    rx: 1.4,
    transform: "matrix(0.445255 0.895404 0.895404 -0.445255 23.0668 8.46875)",
    fill: "#75B2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1379 27.7967L13.3705 26.8548C13.2176 26.8166 13.0759 26.7428 12.957 26.6394L10.1379 24.189",
    stroke: "#F1B883",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_3048"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.602295 0.626709)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/Handshake.6f0bb4017cf37d8c44a793cc983cf8ad.svg";
export { ForwardRef as ReactComponent };